import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
    ModalCloseButton,
    Text,
    Button,
    HStack,
} from '@chakra-ui/react';
import type { InvoiceType } from '../../types/invoice';

const LABELS: Record<InvoiceType, string> = {
    received: 'Received',
    returned: 'Credited',
    return_slip: 'Return Slip',
    sublet: 'Sublet',
};

export interface InvoiceChangeInvoiceTypeModalProps {
    isOpen: boolean;
    onClose: () => void;
    isLoading: boolean;
    currentType: InvoiceType;
    nextType: InvoiceType;
    onConfirm: () => void;
}

const InvoiceChangeInvoiceTypeModal = ({
    isOpen,
    onClose,
    isLoading,
    currentType,
    nextType,
    onConfirm,
}: InvoiceChangeInvoiceTypeModalProps) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose} size="md">
            <ModalOverlay />
            <ModalContent>
                <ModalHeader fontSize="xl" fontWeight="bold" color="gray.900">
                    Change invoice type?
                </ModalHeader>
                <ModalCloseButton />
                <ModalBody pb={4}>
                    <Text fontSize="md" color="gray.600" mb={3}>
                        Are you sure you want to change the invoice type from{' '}
                        <strong>{LABELS[currentType]}</strong> to <strong>{LABELS[nextType]}</strong>?
                    </Text>
                    <Text fontSize="md" color="gray.600">
                        Your edits and line-level NEX matches will be cleared. All invoice fields will be reset to the
                        original extraction snapshot (except the new type), then the full reconciliation process will run
                        again (NEX matching, flags, and totals).
                    </Text>
                </ModalBody>
                <ModalFooter>
                    <HStack spacing={3}>
                        <Button size="action" variant="outlineGray" onClick={onClose}>
                            Cancel
                        </Button>
                        <Button size="action"
                            bg="#0071E3"
                            color="white"
                            _hover={{ bg: '#3544a0' }} onClick={onConfirm} isLoading={isLoading} loadingText="Updating…">
                            Change type and reconcile
                        </Button>
                    </HStack>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default InvoiceChangeInvoiceTypeModal;
